import React from 'react'

import {
  BrowserRouter,
  Routes,
  Route,
} from 'react-router-dom'

import DashboardLayout from './layouts/DashboardLayout/DashboardLayout'

import AuthPage from './pages/Auth/Auth'
import Dashboard from './pages/Dashboard/Dashboard'
import CatalogPage from './pages/Catalog/CatalogPage'
import EditProductPage from './pages/Catalog/EditProductPage'
import OrdersPage from './pages/Orders/OrdersPage'
import VouchersPage from './pages/Vouchers/VouchersPage'
import CreateVoucherPage from './pages/Vouchers/CreateVoucherPage'
import CreatePromoCodePage from './pages/Vouchers/CreatePromoCodePage'
import PointsManagementPage from './pages/PointsManagement/PointsManagementPage'
import PaymentConfigPage from './pages/PaymentConfig/PaymentConfigPage'
import SalesReportPage from './pages/SalesReport/SalesReportPage'
import CustomersPage from './pages/Customers/CustomersPage'
import StaffRolesPage from './pages/Staff/StaffRolesPage'
import ProfilePage from './pages/Profile/ProfilePage'
import ProtectedRoute from './routes/ProtectedRoute'
import StoreSetupPage from './pages/StoreSetup/StoreSetupPage'
import AddOutletPage from './pages/StoreSetup/AddOutletPage'

import CampaignLinksPage from './pages/CampaignLinks/CampaignLinksPage'
import CampaignLinkDetailPage from './pages/CampaignLinks/CampaignLinkDetailPage'
import CampaignLinkFormPage from './pages/CampaignLinks/CampaignLinkFormPage'
import Error404 from './pages/utility/Error404'
import NotAuthorized from './pages/utility/NotAuthorized'
// import VouchersPage from './pages/CampaignLinks/CampaignLinksPage'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        
        <Route
          path="/login"
          element={<AuthPage />}
        />

        <Route element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
          <Route
            path="/"
            element={<Dashboard />}
          />

          <Route
            path="/catalog"
            element={<CatalogPage />}
          />

          <Route
            path="/products/:id/edit"
            element={<EditProductPage />}
          />

          <Route
            path="/orders"
            element={<OrdersPage />}
          />
          <Route
            path="/orders/:id"
            element={<OrdersPage />}
          />

          <Route
            path="/vouchers"
            element={<VouchersPage />}
          />

            <Route
                path="/vouchers/create-reward"
                element={<CreateVoucherPage />}
            />

            <Route
                path="/vouchers/create-promo"
                element={<CreatePromoCodePage />}
            />

          <Route
            path="/points-management"
            element={<PointsManagementPage />}
          />

          <Route
            path="/payment-config"
            element={<PaymentConfigPage />}
          />

          <Route
            path="/store-setup"
            element={<StoreSetupPage />}
          />

          {/* <Route
            path="/outlet-setup/:type"
            element={<AddOutletPage />}
          /> */}

          <Route
            path="/outlet-setup/:type/:id"
            element={<AddOutletPage />}
          />

          <Route
            path="/sales-reporting"
            element={<SalesReportPage />}
          />
          <Route
            path="/customers"
            element={<CustomersPage />}
          />
          <Route
            path="/staff"
            element={<StaffRolesPage />}
          />
          <Route
            path="/profile"
            element={<ProfilePage />}
          />

          <Route
            path="/marketing/links"
            element={<CampaignLinksPage />}
          />

          <Route
            path="/marketing/links/create"
            element={<CampaignLinkFormPage />}
          />

          <Route
            path="/marketing/links/:id/edit"
            element={<CampaignLinkFormPage />}
          />

          <Route
            path="/marketing/links/:id"
            element={<CampaignLinkDetailPage />}
          />
        </Route>
        <Route path="*" element={<Error404 />} />
        <Route path="/unauthorized" element={<NotAuthorized />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App